/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconMoon = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        className="icon-moon-group"
        transform="translate(1 1)"
      >
        <circle
          cx={12}
          cy={12}
          r={12}
          stroke={stroke}
          strokeWidth={weight === "normal" ? 1.5 : 1}
          className="icon-moon-crescent icon-moon-rim"
        />
        <path
          fill="currentColor"
          d="M8.572.497c4.956 1.475 8.57 6.067 8.57 11.503s-3.614 10.028-8.57 11.503C3.614 22.028 0 17.436 0 12 0 6.596 3.572 2.026 8.484.523l.088-.026z"
          className="icon-moon-shadow"
        />
      </g>
    </svg>
  ),
);
